import { memo, type ReactNode } from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

import {
  type MemberRoleSelectProps,
  ORGANIZATION_ROLE_LABELS,
  ORGANIZATION_ROLE_LIST,
  type OrganizationRoleKey,
} from './members.interface'

/**
 * A dropdown selector for organization member roles.
 * Allows selection between admin and member roles.
 */
const MemberRoleSelectBase: React.FC<MemberRoleSelectProps> = ({
  value,
  onChange,
  isDisabled = false,
  className,
}): ReactNode => {
  const handleValueChange = (newValue: string): void => {
    onChange(newValue as OrganizationRoleKey)
  }

  return (
    <Select value={value} onValueChange={handleValueChange} disabled={isDisabled}>
      <SelectTrigger className={cn('member-role-select w-[120px]', className)}>
        <SelectValue placeholder="Select role" />
      </SelectTrigger>
      <SelectContent>
        {ORGANIZATION_ROLE_LIST.map((role) => (
          <SelectItem key={role} value={role} className="member-role-select-item">
            {ORGANIZATION_ROLE_LABELS[role]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export const MemberRoleSelect = memo(MemberRoleSelectBase)

MemberRoleSelect.displayName = 'MemberRoleSelect'
